import _  from 'lodash';
import { Component } from '@angular/core';
import { LoadingService, ForwarderService, Country, BannerSpecialityModel, BannerModel, AlertService} from '../../../services/index';
import { Util } from '../../../utils/index';
import { Router } from '@angular/router';
import { ActivatedRoute, ParamMap, Params } from '@angular/router';

declare var $:any;

@Component({
  selector: 'promotion',
  templateUrl: 'promotion.html'
})
export class PromotionComponent {
  corpId;
  corpInfo;
  promotionList: Array<BannerModel> = [];
  promotionListByCountry: Array<any> = [];
  countryList: Array<String> = [];
  promotion: BannerModel;
  promotionCopy;
  pIndex;
  ppIndex;
  isEditing: boolean = false;
  errorMessage: string = '';

  showPromotionInfo:boolean = false;
  specialityItemList;

  cntryNm;

  promotionWarning:string = null;

  dateFomatter: Function = Util.dateFomatter;

  bannerTypeOption = [
    { value: 0, label : '해상 스케줄 상단' },
    { value: 2, label : '항공 스케줄 상단' }
  ];


  constructor(
    private loadingService: LoadingService,
    private forwarderService: ForwarderService,
    private alertService:AlertService,
    private route:ActivatedRoute
    ) {}

  ngAfterViewInit(): void {
    this.loadingService.isClose = true;
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params: Params) => {

      this.corpId = params.params.corpId;

      this.forwarderService.getCorpInfo(this.corpId).subscribe(
        resp => {
          if(resp.result) {
            this.corpId = resp.data.corpId;
            this.corpInfo = resp.data;
            this.getPromotion();
          } else {
            this.promotionWarning = resp.errorMsg;
          }
        }
      );
    });
    

    this.forwarderService.getSpecialItemList().subscribe(
      resp=> {
        if(resp.result) {
          this.specialityItemList = resp.data;
        } else {
          $.sweetModal({
            content: resp.errorMsg,
            icon: $.sweetModal.ICON_WARNING,
          });
        }
      } 
    );
  }

  getPromotion(){
    this.forwarderService.getPromotion(this.corpId).subscribe(
      resp => {
        if(resp.result) {
          this.promotionList = resp.data;
          this.getPromotionByCountry(this.promotionList)

        } else {
          this.promotionWarning = resp.errorMsg;
        }
      }     
    );
  }


  getPromotionByCountry(promotions) {
    this.promotionListByCountry = [];
    let countryList:any = [];
    for(let promo of promotions) {
      countryList.push(promo.cntryNm);
    };

    this.countryList = _.uniq(countryList);

    for(let country of this.countryList) {
      this.promotionListByCountry.push({cntryNm: country, promolist: []});
    };

    for(let promotionList of this.promotionListByCountry) {
      for(let promo of promotions) {
        if(promo.cntryNm == promotionList.cntryNm) {
          promotionList.promolist.push(promo);
        }
      }
    }
  }


  addPromotion() {
    this.promotion = new BannerModel();
    this.promotion.bannerSpecialityList = [];
    this.promotion.corpId = this.corpId;
    this.promotion.bannerTypeCd = 0;
    this.promotion.bannerStatusCd = 0;
    this.promotion.delYn = 0;
    this.showPromotionInfo = true;
    $('body').css('overflow', 'hidden');
  }

  openPromotionInfo(promotion, i, k) {
    this.promotion = promotion;
    this.promotionCopy = _.cloneDeep(promotion);
    this.isEditing = true;
    this.pIndex = i;
    this.ppIndex = k;
    this.showPromotionInfo = true;
    this.cntryNm = null;
    $('body').css('overflow', 'hidden');
  }

  closePromotionInfo() {
    this.showPromotionInfo = false;
    this.promotion = null;
    this.cntryNm = null;
    $('body').css('overflow', 'auto');
    if(this.isEditing) {
      if(this.promotionListByCountry[this.ppIndex].promolist[this.pIndex] != null) this.promotionListByCountry[this.ppIndex].promolist[this.pIndex] = _.cloneDeep(this.promotionCopy);
      this.isEditing = false;
    }    
  }

  countrySelected(event) {
    if(event != null) {
      this.promotion.cntryCd = event.cntryCd;
      this.cntryNm = event.cntryNm;
    } else {
      this.promotion.cntryCd = null;
      this.cntryNm = null;
    }
  }

  onChangeSpc(specialityItem, checked) {
    if (checked) {
      this.promotion.bannerSpecialityList.push(specialityItem);
    } else {
      let index = _.findIndex(this.promotion.bannerSpecialityList, {itemId: specialityItem.itemId});
      this.promotion.bannerSpecialityList.splice(index, 1);
    }
  }

  getThisItemIsCheckd(itemId) {
    if(_.findIndex(this.promotion.bannerSpecialityList, {itemId: itemId}) >= 0) {
      return 'checked';
    } else {
      return null;
    }
  }

  bannerSelected(event, promotion: BannerModel) {
    if(promotion.isActivity == 0) {
      promotion.isActivity = 1;
    }else{
      promotion.isActivity = 0; 
    }

    this.forwarderService.postPromotionActive(this.corpId, promotion).subscribe(
      resp => {
        if(resp.result) {
          
        } else {
          $.sweetModal(resp.errorMsg);
          setTimeout(() => {
          }, 2000);
        }
      }
    );
  }

  savePromotion() {
    this.forwarderService.postPromotion(this.corpId, this.promotion).subscribe(
      resp => {
        if(resp.result) {
          $.sweetModal({
            content: '저장되었습니다.',
            icon: $.sweetModal.ICON_SUCCESS,
          });
        } else {
          $.sweetModal({
            content: resp.errorMsg,
            icon: $.sweetModal.ICON_SUCCESS,
          });
        }
        this.closePromotionInfo();
        this.getPromotion();
      }
    );
  }

  postRequestPublish(promotion, type) {
    this.promotionCopy = _.clone(promotion);

    if(promotion.cntryCd == null) {
      $.sweetModal({
        content: "이 프로모션의 노출구간을 설정해주세요.",
        icon: $.sweetModal.ICON_WARNING,
      });

      return;
    }

    let promo = promotion;

    let msg = '';

    if(type == 'REQUEST') {
      msg = '요청이 완료되었습니다.';
      promo.bannerStatusCd = 1;
    }
    if(type == 'APPROVAL') {
      msg = '승인이 완료되었습니다.';
      promo.bannerStatusCd = 2;
    }
    if(type == 'CANCEL') {
      msg = '요청이 취소되었습니다.';
      promo.bannerStatusCd = 3;
    }

    this.forwarderService.postBannerStatus(this.corpId, promotion).subscribe(
      resp => {
        if(resp.result) {
          $.sweetModal({
            content: msg,
            icon: $.sweetModal.ICON_SUCCESS,
          });
        } else {
          let body = JSON.parse(resp._body);
          $.sweetModal({
            content: body.errorMsg,
            icon: $.sweetModal.ICON_WARNING,
          });
          promo = this.promotionCopy;
        }
        this.getPromotion();
      }
    )
  }


  deletePromotion() {
    let that = this;
    this.pIndex = _.findIndex(this.promotionList, {bannerId: this.promotion.bannerId});
    $.sweetModal.confirm('프로모션을 삭제하시겠습니까?', function() {
      that.forwarderService.deletePromotion(that.corpId, that.promotion.bannerId).subscribe(
        resp => {
          if(resp.result) {
            that.alertService.success("삭제가 완료되었습니다.");
          } else {
            that.alertService.error(resp.errorMsg);
          }
          that.closePromotionInfo();
          that.getPromotion();
        }
      );
    }, function() {
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/fwdr/detail/promotion.ts